import { render, staticRenderFns } from "./information-list.vue?vue&type=template&id=76291636&scoped=true&"
import script from "./information-list.vue?vue&type=script&lang=js&"
export * from "./information-list.vue?vue&type=script&lang=js&"
import style0 from "./information-list.vue?vue&type=style&index=0&id=76291636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76291636",
  null
  
)

export default component.exports